import React from "react";

const AboutAreaOne = () => {
  return (
    <>
      {/* ================== AboutAreaOne start  ==================*/}
      <div className='about-area pd-top-120'>
        <div className='container'>
          <div className='row'>
            <div className='col-lg-6'>
              <div
                className='about-thumb-inner pe-xl-5 me-xl-5 '
                data-aos='fade-right'
                data-aos-delay='100'
                data-aos-duration='1500'
              >
                <img
                  className='main-img rounded'
                  src='assets/img/about/vision.png'
                  alt='img'
                  style={{objectFit: 'cover'}}
                />
              </div>
            </div>
            <div
              className='col-lg-6 '
              data-aos='fade-left'
              data-aos-delay='100'
              data-aos-duration='1500'
            >
              <div className='section-title mt-5 mt-lg-0'>
                <h6 className='sub-title'>OUR VISION</h6>
                <h2 className='title'>
                Manufacturer and Exporter of all types <span>Forging</span> Products
                </h2>
                <p className='content mb-4 mb-xl-5'>
                To be the preferred, successful and trusted long-term partners to all our stakeholders – client’s, associates and our employees. For this to be possible, we will be viable and relevant through practical innovation and a continuous focus on efficiency and consistency.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* ================== AboutAreaOne End  ==================*/}
    </>
  );
};

export default AboutAreaOne;
